const Constants = {
    lastSelectedNavigationItem: 'lastSelectedNavigationItem',
};

export default Constants;
